(function(){
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.12 });
  document.querySelectorAll('.mx-reveal').forEach(function(el){ io.observe(el); });

  var counterIO = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting && !e.target.dataset.done){
        e.target.dataset.done = '1';
        var target = parseFloat(e.target.dataset.target);
        var suffix = e.target.dataset.suffix || '';
        var duration = 1800;
        var start = performance.now();
        var step = function(now){
          var t = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - t, 3);
          var val = target % 1 === 0 ? Math.floor(eased * target) : (eased * target).toFixed(1);
          if(target >= 1000 && target % 1 === 0){ val = parseInt(val).toLocaleString('en-US'); }
          e.target.textContent = val + suffix;
          if(t < 1) requestAnimationFrame(step);
          else {
            var finalVal = target;
            if(target >= 1000 && target % 1 === 0){ finalVal = target.toLocaleString('en-US'); }
            else if(target % 1 !== 0){ finalVal = target.toFixed(1); }
            e.target.textContent = finalVal + suffix;
          }
        };
        requestAnimationFrame(step);
      }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('[data-target]').forEach(function(el){ counterIO.observe(el); });

  var tiltCards = document.querySelectorAll('.mx-hero-prod-card');
  tiltCards.forEach(function(tilt){
    var wrap = tilt.parentElement;
    wrap.addEventListener('mousemove', function(e){
      var rect = wrap.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      tilt.style.transform = 'rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) translateZ(20px)';
    });
    wrap.addEventListener('mouseleave', function(){ tilt.style.transform = ''; });
  });

  var notif = document.getElementById('mx-live-notif');
  if(notif && window.MIXIO_NOTIFS && window.MIXIO_NOTIFS.length){
    var notifText = document.getElementById('mx-live-notif-text');
    var notifMeta = document.getElementById('mx-live-notif-meta');
    var notifImg = document.getElementById('mx-live-notif-img');
    var pool = window.MIXIO_NOTIFS.slice().sort(function(){ return Math.random() - 0.5; });
    var i = 0;
    var showNotif = function(){
      var n = pool[i % pool.length];
      if(notifText) notifText.innerHTML = '<strong>' + n.name + '</strong> just bought <strong>' + n.product + '</strong>';
      if(notifMeta) notifMeta.textContent = n.time;
      if(notifImg && n.img) notifImg.src = n.img;
      if(n.url){ notif.style.cursor = 'pointer'; notif.onclick = function(){ window.location.href = n.url; }; }
      notif.classList.add('show');
      setTimeout(function(){ notif.classList.remove('show'); }, 5500);
      i++;
    };
    setTimeout(showNotif, 4500);
    setInterval(showNotif, 13000);
  }
})();
